import React , { useState , useEffect } from 'react'
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils'
import Table from "../../components/table"


function DraftCompanies(props: any) {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3) 
  const [data, setData] = useState<any>([])
  const [total, setTotal] = useState<number>()
  
  useEffect(() => { 
    if(props.positions){
      setData(props && props.positions &&  props.positions)
      setTotal(props.total)    
    }
  }, [props.positions, props.total])

  const pageChange = (data: any) => {
 
    
  }

  const pageSize = (pageSize: any, pageNumber: number) => {    
    
    props.pageSize(pageNumber, pageSize);
    
  }

  return (
    <section className="tableStyle">
      <Table setSort={props.setSort}   applySort={props.applySort} getTablesValues={''} pageSize={pageSize} data={props.data} rowClick={''} total={''} pageChange={''} type={'registrationApproval'} approveOrRejectCustomer={props.approveOrRejectCustomer} draftCompany={true}/>
    </section>
  )
}

export default DraftCompanies